import { RPC_REQUEST_TIMEOUT } from '@exodus/web3-constants';
import { validate as validateDeps, validateCommonDeps, } from '@exodus/web3-rpc-handlers';
import { exposeHandlers } from './exposeHandlers.js';
import { validateRequest } from './validator.js';
export { default as createEVMDepsFactory } from './createEVMDeps.js';
const validateEVMDeps = (evm) => {
    const requiredKeys = [
        'chainId',
        'forwardRequest',
        'getAddress',
        'getEstimatedGas',
        'getFeeData',
        'getCustomFeeData',
        'getNonce',
        'sendRawTransaction',
        'simulateEthereumTransactions',
        'getActiveWalletAccountData',
        'transactionSigner',
        'messageSigner',
    ];
    const optionalKeys = [
        'getSupportedChainIds',
        'onEthWalletWatchAssetRequest',
        'addEthereumChain',
    ];
    validateDeps(evm, requiredKeys, optionalKeys);
};
function validateEVMsDeps(evms) {
    const chainIds = evms.map(({ chainId }) => chainId);
    const uniqueChainIds = [...new Set(chainIds)];
    if (chainIds.length !== uniqueChainIds.length) {
        throw new Error('EVMs must have unique chain IDs');
    }
    evms.forEach(validateEVMDeps);
}
export function validateRequestWithEVMPrefix(request) {
    if (typeof request !== 'object') {
        return validateRequest(request);
    }
    const originalMethod = request?.method;
    if (!originalMethod || typeof originalMethod !== 'string') {
        return validateRequest(request);
    }
    const underscorePosition = originalMethod.indexOf('_');
    if (underscorePosition === -1) {
        return validateRequest(request);
    }
    // 0x1_eth_getAccounts -> eth_getAccounts
    const methodWithoutPrefix = originalMethod.slice(underscorePosition + 1);
    // NOTE: validateRequest can deeply mutate the argument, e.g. removing additional properties.
    // We should always use the result of validateRequest() call, and never use the original argument again.
    const validated = validateRequest({ ...request, method: methodWithoutPrefix });
    return { ...validated, method: originalMethod };
}
export const registerRPCHandlers = ({ deps, RPC, transport, }) => {
    validateCommonDeps(deps, ['evms']);
    validateEVMsDeps(deps.evms);
    if (!RPC) {
        throw new Error('"RPC" constructor parameter is required');
    }
    if (!transport) {
        throw new Error('"transport" parameter is required');
    }
    const { app, evms = [], wallet } = deps;
    const rpc = new RPC({
        transport,
        parse: validateRequestWithEVMPrefix,
        getIsDevelopmentMode: () => app.isDevelopmentEnvironment?.() ?? false,
        requestTimeout: RPC_REQUEST_TIMEOUT,
    });
    for (const evm of evms) {
        const evmDeps = { ...app, ...evm, ...wallet };
        exposeHandlers(rpc, evmDeps);
    }
    return rpc;
};
